import GameState from 'slotworks/model/game-state';
import { Exit } from 'slotworks/state-machine/data/exit';
import Decision from 'slotworks/state-machine/decisions/decision';

export default class IsTreasureBonusCheck extends Decision {
    private bonusId: string;

    constructor(bonus: string) {
        super();
        this.bonusId = bonus;
    }

    public evaluate() {
        const record = GameState.getCurrentGame().latestRecord();
        let triggered = false;

        if (record?.isBonusTriggered(this.bonusId)) {
            triggered = true;
        }

        return triggered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./src/desicions/treasure-bonus-check.ts